export class Permission {
    constructor(
        public id = 0,
        public name = '',
        public action = '',
        public menuRoute = ''
    ) {}
}
